import { SefazAcronymsService } from "core/service";
import { Singleton } from "util";

@Singleton
class SefazAcronymsRepository {
  async tearUp() {
    this.sefazAcronymsService = await SefazAcronymsService.getInstance();
  }

  async getSefazNcm() {
    return this.sefazAcronymsService.getSefazNcm();
  }

  async getSefazCfop() {
    return this.sefazAcronymsService.getSefazCfop();
  }

  async getSefazCest() {
    return this.sefazAcronymsService.getSefazCest();
  }

  async getSefazCsosn() {
    return this.sefazAcronymsService.getSefazCsosn();
  }

  async filterSefazNcm({ filters = [] }) {
    return this.sefazAcronymsService.filterSefazNcm(filters);
  }

  async filterSefazCfop({ filters = [] }) {
    return this.sefazAcronymsService.filterSefazCfop(filters);
  }

  async filterSefazCest({ filters = [] }) {
    return this.sefazAcronymsService.filterSefazCest(filters);
  }

  async filterSefazCsosn({ filters = [] }) {
    return this.sefazAcronymsService.filterSefazCsosn(filters);
  }
}

export default SefazAcronymsRepository;



// WEBPACK FOOTER //
// ./src/core/repository/sefaz-acronyms.repository.js